import { Injectable } from '@angular/core';

type ConsoleTool = Console & {isHavingQueryParamDebug: boolean};

const getQueryParamDebug = () => (new URLSearchParams(location.search))?.get('debug')?.trim() === 'true';

/**
 * @deprecated Please use `AppLoggerService` instead. Only use this if its outside Angular environment.
 *
 * ===================================
 *
 * Proxy the usage of console command.
 *
 * Console command will only get executed if there is queryParams `debug=true`
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/API/console)
 */
/* eslint-disable no-console, azavista-frontend/no-console */
export const consoleTool: ConsoleTool = {
    ...console,
    isHavingQueryParamDebug: getQueryParamDebug(),
    log: (...params) => consoleTool.isHavingQueryParamDebug ? console.log(...params) : null,
    info: (...params) => consoleTool.isHavingQueryParamDebug ? console.info(...params) : null,
    debug: (...params) => consoleTool.isHavingQueryParamDebug ? console.debug(...params) : null,
    error: (...params) => console.error(...params),
    group: (...params) => consoleTool.isHavingQueryParamDebug ? console.group(...params) : null,
    groupEnd: () => consoleTool.isHavingQueryParamDebug ? console.groupEnd() : null,
    groupCollapsed: (...params) => consoleTool.isHavingQueryParamDebug ? console.groupCollapsed(...params) : null,
    warn: (...params) => consoleTool.isHavingQueryParamDebug ? console.warn(...params) : null,
};
/* eslint-enable no-console, azavista-frontend/no-console */

export enum LogLevel {
    log = 'log',
    debug = 'debug',
    info = 'info',
    warn = 'warn',
    error = 'error',
}

@Injectable({
    providedIn: 'root'
})
export class AppLoggerService {
    group = consoleTool.group;
    groupEnd = consoleTool.groupEnd;
    groupCollapsed = consoleTool.groupCollapsed;

    // log<L extends LogLevel>(logLevel: L, message?: any, ...params: Parameters<Console[L]>): void {
    //     return consoleTool[logLevel](message, ...params);
    // }
    log<L extends LogLevel>(logLevel: L,...params: Parameters<Console[L]>): void {
        return consoleTool[logLevel](...params);
    }
}
